import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';

var _excluded = ["size", "className"];
var Heading = function Heading(_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 3 : _ref$size,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('Heading', otherProps);
  var finalClasses = classnames('C-Heading', _defineProperty({}, "--size-h".concat(size), size), className);
  var As = "h".concat(size);
  return /*#__PURE__*/React.createElement(As, _extends({
    ref: ref,
    className: finalClasses
  }, otherProps));
};
Heading.displayName = 'Heading';
var Heading$1 = /*#__PURE__*/React.forwardRef(Heading);

export { Heading$1 as default };
